<template>
  <div>
    <div class="fixed-header">
      <div :gl-tooltip="queryId ? 'Excel出力' : ''" gl-tooltip-direction="down">
        <gl-button
          :disabled="!queryId"
          @click="downloadExcel"
          icon-button
          raised
        >
          <md-icon> <font-awesome-icon icon="file-excel"/></md-icon>
        </gl-button>
      </div>
      <div gl-tooltip="ヘルプ" gl-tooltip-direction="down">
        <gl-button icon-button @click="moveToHelp" raised>
          <gl-icon-help />
        </gl-button>
      </div>
    </div>
    <table>
      <colgroup>
        <col class="row-header" />
        <col class="component-col" />
        <col class="component-col" />
      </colgroup>
      <tbody>
        <tr>
          <td class="header-cell" colspan="3">
            <div>
              <a
                class="filter-open-link"
                href="#"
                @click.prevent="visibleCategoryDialog = true"
                >商品分類</a
              >
            </div>
            <div class="error">{{ errorCategory }}</div>
            <div v-if="!errorCategory">{{ categorySummaryText }}</div>
          </td>
        </tr>
        <tr>
          <td class="header-cell" colspan="3">
            <div style="display:flex; justify-content:center;">
              <filter-customer v-bind.sync="queryFilter.customer" />
            </div>
          </td>
        </tr>
        <tr>
          <td class="header-cell">
            <div style="text-align: right;">
              <gl-sub-text>期間</gl-sub-text>
            </div>
            <div style="text-align: left;">
              <gl-sub-text>店舗</gl-sub-text>
            </div>
          </td>
          <td class="header-cell stick-top">
            <!-- ********************** -->
            <!-- 当期間選択 -->
            <!-- ********************** -->
            <div>
              <a
                class="filter-open-link"
                href="#"
                @click.prevent="showTermDialog('base')"
                >当期間</a
              >
              <div class="error">{{ errorTermBase }}</div>
              <div v-if="!errorTermBase">
                {{ termBaseSummaryText }}
              </div>
            </div>
          </td>
          <td class="header-cell stick-top">
            <!-- ********************** -->
            <!-- 前期間選択 -->
            <!-- ********************** -->
            <div>
              <a
                class="filter-open-link"
                href="#"
                @click.prevent="showTermDialog('compare')"
                >前期間</a
              >
              <div class="error">{{ errorTermCompare }}</div>
              <div v-if="!errorTermCompare">
                {{ termCompareSummaryText }}
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td rowspan="3" class="header-cell">
            <!-- ********************** -->
            <!-- 自店選択 -->
            <!-- ********************** -->
            <div>
              <a
                class="filter-open-link"
                href="#"
                @click.prevent="showStoreDialog('base')"
                >自店</a
              >
            </div>
            <div class="error">{{ errorStoreBase }}</div>
            <div v-if="!errorStoreBase">{{ storeBaseSummaryText }}</div>
          </td>
        </tr>
        <tr>
          <td>
            <!-- ******************** -->
            <!-- 当期間ランク選択 -->
            <!-- ******************** -->
            <query-roots-select-rank
              v-if="
                master.ranks.rankValues && master.ranks.rankValues.length > 0
              "
              :ranks.sync="ranks1"
              v-bind="master.ranks"
              outOfRankText="流出"
            />
            <gl-sub-text v-else
              >商品分類で選択されている企業にランク設定がありません</gl-sub-text
            >
          </td>
          <td>
            <!-- ******************** -->
            <!-- 前期間ランク選択 -->
            <!-- ******************** -->
            <query-roots-select-rank
              v-if="
                master.ranks.rankValues && master.ranks.rankValues.length > 0
              "
              :ranks.sync="ranks2"
              v-bind="master.ranks"
              outOfRankText="流入"
            />
            <gl-sub-text v-else
              >商品分類で選択されている企業にランク設定がありません</gl-sub-text
            >
          </td>
        </tr>
        <tr>
          <td>
            <!-- ***************************** -->
            <!-- 自店・当期間ツリー -->
            <!-- ***************************** -->
            <query-roots-tree
              v-if="hasResult"
              v-bind="treeFigures1"
              :enable-evaluation-click="enableEvaluationClick"
              :enable-customer-link-click="enableLinkClick"
              @customer-count-link-click="downloadCustomers(1, 1)"
              @evaluation-click="moveToDetail"
            />
            <query-roots-tree-empty v-else />
            <md-field class="find-roots-by">
              <md-select v-model="findRootsBy">
                <md-option value="term_x_store"
                  >期間・店間比でRootsを探る</md-option
                >
                <md-option value="term">期間比でRootsを探る</md-option>
              </md-select>
            </md-field>
          </td>
          <td>
            <!-- ***************************** -->
            <!-- 自店・前期間ツリー -->
            <!-- ***************************** -->
            <query-roots-tree
              v-if="hasResult"
              v-bind="treeFigures2"
              :enable-customer-link-click="enableLinkClick"
              @customer-count-link-click="downloadCustomers(1, 2)"
            />
            <query-roots-tree-empty v-else />
          </td>
        </tr>
        <tr>
          <td rowspan="2" class="header-cell">
            <!-- ********************** -->
            <!-- 比較店選択 -->
            <!-- ********************** -->
            <div>
              <a
                class="filter-open-link"
                href="#"
                @click.prevent="showStoreDialog('compare')"
                >比較店</a
              >
            </div>
            <div class="error">{{ errorStoreCompare }}</div>
            <div v-if="!errorStoreCompare">{{ storeCompareSummaryText }}</div>
          </td>
        </tr>
        <tr>
          <td>
            <!-- ******************************* -->
            <!-- 比較店・当期間ツリーコンポーネント -->
            <!-- ******************************* -->
            <query-roots-tree
              v-if="hasResult"
              v-bind="treeFigures3"
              :enable-customer-link-click="enableLinkClick"
              @customer-count-link-click="downloadCustomers(2, 1)"
            />
            <query-roots-tree-empty v-else />
          </td>
          <td>
            <!-- ******************************* -->
            <!-- 比較店・前期間ツリーコンポーネント -->
            <!-- ******************************* -->
            <query-roots-tree
              v-if="hasResult"
              v-bind="treeFigures4"
              :enable-customer-link-click="enableLinkClick"
              @customer-count-link-click="downloadCustomers(2, 2)"
            />
            <query-roots-tree-empty v-else />
          </td>
        </tr>
      </tbody>
    </table>

    <div
      class="fixed-action-area"
      :gl-tooltip="buttonToolTip"
      gl-tooltip-direction="left"
    >
      <button-execute-query
        @click="executeQueryFilterSaveWrapper"
        class="animated"
        :disabled="!(canStartQuery && canTabSwitch)"
        :will-plane-fly="canStartQuery"
        :class="{ tada: canStartQuery }"
        :enable-dump-upload="$store.getters.isAdmin"
        @dump-uploaded="handleDumpUploaded"
      />
    </div>

    <!-- ******************************* -->
    <!-- Dialogs -->
    <!-- ******************************* -->
    <md-dialog class="category-dialog" :md-active.sync="visibleCategoryDialog">
      <md-dialog-content>
        <gl-select-company :company.sync="queryFilter.category.company" />
        <filter-category v-bind.sync="queryFilter.category" />
      </md-dialog-content>
    </md-dialog>

    <md-dialog class="term-dialog" :md-active.sync="visibleTermDialog">
      <md-dialog-content>
        <!-- TODO なんかダサい、、、 -->
        <filter-term
          v-if="visibleDate === 'base'"
          v-bind.sync="queryFilter.term.base"
        />
        <filter-term
          v-if="visibleDate === 'compare'"
          v-bind.sync="queryFilter.term.compare"
        />
      </md-dialog-content>
    </md-dialog>

    <md-dialog class="store-dialog" :md-active.sync="visibleStoreDialog">
      <md-dialog-content>
        <filter-store
          v-if="visibleStore === 'base'"
          v-bind.sync="queryFilter.store.base"
        />
        <filter-store
          v-if="visibleStore === 'compare'"
          v-bind.sync="queryFilter.store.compare"
        />
      </md-dialog-content>
    </md-dialog>

    <!-- 顧客ファイルアップロード中通知 -->
    <md-dialog
      :md-active.sync="uploadingCustomerFile"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
    >
      <md-dialog-content>
        <div style="display:flex;align-items:center">
          <spinner :diameter="30" />
          <span style="margin-left:var(--spacing-medium)">
            顧客一覧ファイルをアップロードしています...
          </span>
        </div>
      </md-dialog-content>
    </md-dialog>

    <md-dialog-alert
      :md-active.sync="hasCustomerFileUploadWarning"
      :md-content="customerFileUploadWarningMessage"
      md-confirm-text="Close"
    />

    <md-dialog
      class="querying-dialog"
      :md-active.sync="querying"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
    >
      <md-dialog-content>
        <div class="spinner-container">
          <img src="@/assets/images/Web_hosting.svg" />
          <spinner />
        </div>
      </md-dialog-content>
    </md-dialog>

    <!-- 分析結果0件警告 -->
    <md-dialog-alert
      :md-active.sync="showNoResultDialog"
      md-content="対象となるデータがありませんでした"
      md-confirm-text="Close"
    />

    <md-snackbar
      md-position="center"
      :md-duration="snackbar.duration"
      :md-active.sync="snackbar.show"
      md-persistent
    >
      {{ snackbar.message }}
    </md-snackbar>
  </div>
</template>

<script>
import { Subject, from } from 'rxjs'
import { debounceTime, switchMap, filter } from 'rxjs/operators'
import { mergeWith, isArray } from 'lodash'
import moment from 'moment'

import QueryRootsTree from '@/components/QueryRootsTree.vue'
import QueryRootsTreeEmpty from '@/components/QueryRootsTreeEmpty.vue'
import QueryRootsSelectRank from '@/components/QueryRootsSelectRank.vue'
import ButtonExecuteQuery from '@/components/ButtonExecuteQuery'
import Spinner from '@/components/Spinner.vue'
import DialogWarning from '@/components/DialogWarning.vue'

// 分析条件
import FilterCustomer from '@/components/FilterCustomer.vue'
import FilterTerm from '@/components/FilterTerm.vue'
import FilterCategory from '@/components/FilterCategory.vue'
import FilterStore from '@/components/FilterStore.vue'

// 分析条件モデル
import category from '@/queryfilter/category'
import term from '@/queryfilter/term'
import store from '@/queryfilter/store'
import customer from '@/queryfilter/customer'

import repository from '@/repositories/Repository'
import { initializeRestrictedQueryFilter } from '@/queryfilter/util'
import { SET_IS_QUERY_FULL_FEATURED } from '@/const/mutation-types'

export default {
  components: {
    QueryRootsSelectRank,
    QueryRootsTree,
    QueryRootsTreeEmpty,
    ButtonExecuteQuery,
    Spinner,
    FilterCategory,
    FilterCustomer,
    FilterTerm,
    FilterStore,
  },
  data() {
    return {
      queryId: undefined,
      resourceName: 'roots',
      uploadingCustomerFile: false,
      hasCustomerFileUploadWarning: false,
      customerFileUploadWarningMessage: undefined,
      querying: false,
      visibleCategoryDialog: false,
      visibleTermDialog: false,
      visibleStoreDialog: false,
      visibleDate: undefined,
      visibleStore: undefined,
      hasResult: false,
      showNoResultDialog: false,
      rankChangeSubject: new Subject(),
      waitingTabSwitch: false,
      /**
       * マスタ
       *
       * 原則マスタは分析条件コンポーネントが持つことになるので最終的にはいらなくなる予感
       */
      master: {
        ranks: {
          rankValues: undefined,
          rankTexts: undefined,
          mThresholds: undefined,
          fThresholds: undefined,
        },
      },
      queryFilter: {
        category: {
          order: 2,
          summaryKey: 'categoryRoots',
          ...category.get(),
        },
        customer: {
          order: 4,
          ...customer.get(),
        },
        term: {
          order: 1,
          summaryKey: 'termPos',
          base: {
            ...term.get(),
          },
          compare: {
            ...term.get(),
          },
          isCompareEnabled: true, // 分析履歴で分析条件表示のために追加（Trueで固定）
        },
        store: {
          order: 3,
          summaryKey: 'storeCompare',
          base: {
            ...store.get(),
          },
          compare: {
            ...store.get(),
          },
        },
      },
      treeFigures1: {
        amountTotal: 0,
        amount: 0,
        compositionRatio: 0,
        customerCount: 0,
        amountPerCustomer: 0,
        receiptPerCustomer: 0,
        amountPerReceipt: 0,
        qtyPerReceipt: 0,
        amountPerQty: 0,
        ratioAmountTotal: 0,
        ratioAmount: 0,
        ratioCompositionRatio: 0,
        ratioCustomerCount: 0,
        ratioAmountPerCustomer: 0,
        ratioReceiptPerCustomer: 0,
        ratioAmountPerReceipt: 0,
        ratioQtyPerReceipt: 0,
        ratioAmountPerQty: 0,
      },
      treeFigures2: {
        amountTotal: 0,
        amount: 0,
        compositionRatio: 0,
        customerCount: 0,
        amountPerCustomer: 0,
        receiptPerCustomer: 0,
        amountPerReceipt: 0,
        qtyPerReceipt: 0,
        amountPerQty: 0,
      },
      treeFigures3: {
        amountTotal: 0,
        amount: 0,
        compositionRatio: 0,
        customerCount: 0,
        amountPerCustomer: 0,
        receiptPerCustomer: 0,
        amountPerReceipt: 0,
        qtyPerReceipt: 0,
        amountPerQty: 0,
      },
      treeFigures4: {
        amountTotal: 0,
        amount: 0,
        compositionRatio: 0,
        customerCount: 0,
        amountPerCustomer: 0,
        receiptPerCustomer: 0,
        amountPerReceipt: 0,
        qtyPerReceipt: 0,
        amountPerQty: 0,
      },
      snackbar: {
        show: false,
        duration: 2000,
        message: '',
      },
    }
  },
  computed: {
    buttonToolTip() {
      if (
        this.errorCategory ||
        this.errorTermBase ||
        this.errorTermCompare ||
        this.errorStoreBase ||
        this.errorStoreCompare
      ) {
        return '分析条件に入力エラーがあります。'
      }
      return ''
    },
    canStartQuery() {
      return !this.buttonToolTip
    },
    canTabSwitch() {
      return !this.waitingTabSwitch
    },
    errorCategory() {
      let err

      const category = this.queryFilter.category
      if (!category.categories || category.categories.length === 0) {
        err = '分類を選択してください'
      }

      return err
    },
    errorTermBase() {
      const term = this.queryFilter.term.base
      if (!(term.dateFrom && term.dateTo)) {
        return '期間を選択してください'
      }
      return undefined
    },
    errorTermCompare() {
      const term = this.queryFilter.term.compare
      if (!(term.dateFrom && term.dateTo)) {
        return '期間を選択してください'
      }
      return undefined
    },
    errorStoreBase() {
      const store = this.queryFilter.store.base
      if (!store.stores || store.stores.length === 0) {
        return '店舗を選択してください'
      }
      return undefined
    },
    errorStoreCompare() {
      const store = this.queryFilter.store.compare
      if (!store.stores || store.stores.length === 0) {
        return '店舗を選択してください'
      }
      return undefined
    },
    categorySummaryText() {
      return `${this.queryFilter.category.categories.length}分類`
    },
    termBaseSummaryText() {
      const term = this.queryFilter.term.base
      return (
        moment(term.dateFrom, 'YYYYMMDD').format('YYYY年M月D日') +
        ' ～ ' +
        moment(term.dateTo, 'YYYYMMDD').format('YYYY年M月D日')
      )
    },
    termCompareSummaryText() {
      const term = this.queryFilter.term.compare
      return (
        moment(term.dateFrom, 'YYYYMMDD').format('YYYY年M月D日') +
        ' ～ ' +
        moment(term.dateTo, 'YYYYMMDD').format('YYYY年M月D日')
      )
    },
    storeBaseSummaryText() {
      const store = this.queryFilter.store.base
      const len = store.stores ? store.stores.length : 0
      return len + '店舗'
    },
    storeCompareSummaryText() {
      const store = this.queryFilter.store.compare
      const len = store.stores ? store.stores.length : 0
      return len + '店舗'
    },
    enableEvaluationClick() {
      return this.ranks1.length > 0 && this.ranks2.length > 0
    },
    enableLinkClick() {
      return this.$store.state.isQueryFullFeatured
    },
    ranks1: {
      get() {
        if (!this.$route.query.ranks1) {
          return []
        }
        return this.$route.query.ranks1.split(',')
      },
      set(ranks) {
        this.updateRouteQuery({ ranks1: ranks.join(',') })
      },
    },
    ranks2: {
      get() {
        if (!this.$route.query.ranks2) {
          return []
        }
        return this.$route.query.ranks2.split(',')
      },
      set(ranks) {
        this.updateRouteQuery({ ranks2: ranks.join(',') })
      },
    },
    findRootsBy: {
      get() {
        if (!this.$route.query.findRootsBy) {
          return 'term_x_store'
        }
        return this.$route.query.findRootsBy
      },
      set(findRootsBy) {
        this.updateRouteQuery({ findRootsBy })
      },
    },
  },
  watch: {
    //
    // queryIdの変化で実施することは以下の3つ
    //
    // 1. 分析IDが提供されている
    //
    //    この画面で結果を表示したい分析IDです。分析ステータスは分析中、若しくは完了
    //    （異常終了含む）両方を考慮に入れる必要があります。
    //
    // 2. 参照分析IDが提供されている
    //
    //    画面遷移により開かれた画面です。参照分析IDで指定された分析IDの分析条件
    //    を使い（一部変更）このResourceで分析します。分析が完了したら分析IDをURLに
    //    セットし、1に飛ばします（結果の表示は1のルートに任せます）。
    //
    // 3. 分析IDも参照分析IDもない
    //
    //    メニューから開いた初期画面です。分析後の画面から戻ってきた場合もこのケースです。
    //    分析条件等を初期状態に戻すのを忘れずに。
    //
    '$route.params.queryId': {
      // 画面表示時にもキャッチできるようにimmediateとしています
      immediate: true,
      async handler(queryId) {
        const referenceId = this.$route.query.reference

        if (queryId) {
          // 1. 分析IDが提供されている
          this.queryId = queryId

          this.querying = true

          // 例えば、分析IDが含まれるURLを直接開いた場合、分析中にリロードした場合などは分析条件
          // の復元が必要です。
          const queryFilter = await this.$longQuery.fetchQueryFilter(queryId)
          if (!queryFilter) {
            throw new Error('分析IDが見つかりませんでした。', queryId)
          }

          const promises = this.applyQueryFilter(queryFilter)
          if (promises && promises.length > 0) {
            await Promise.all(promises.filter(p => p))
          }

          // QueryFilterへの反映が完了し、各条件コンポーネントのエラー判定が
          // 行われることを保証するため、applyQueryFilterによるDOM変更完了を待ちます。
          await this.$nextTick()

          this.$emit('update:activeTab', 'result')

          // 分析は既に完了している場合もありますが、その場合は完了通知を監視に接続した
          // 直後に分析完了通知が飛びます。分析のステータスは気にせず完了待機に入ります。
          this.$queryNotification.connect(queryId)
        } else if (referenceId) {
          // 2. 参照分析IDが提供されている
          const queryFilter = await this.$longQuery.fetchQueryFilter(
            referenceId,
          )
          const override = JSON.parse(this.$route.query.override)
          queryFilter.option.customerSegment = 'rank'

          const mergedQueryFilter = mergeWith(queryFilter, override, (o, s) => {
            return isArray(s) ? s : undefined
          })

          this.applyQueryFilter(mergedQueryFilter)

          this.executeQuery()
        } else {
          // 3. 分析IDも参照分析IDもない
          this.queryId = undefined

          // 保存されている最後の分析条件（画面毎）があれば復元する
          const queryFilter = await this.$longQuery.fetchMenuQueryFilter(
            this.resourceName,
          )
          if (queryFilter) {
            this.applyQueryFilter(queryFilter)
          }
        }
      },
    },
    'queryFilter.category.company': {
      immediate: true,
      async handler(company) {
        // ランクの名称やしきい値は企業に紐付いている
        if (!company) {
          return
        }

        const ranks = await this.$repositories.get('rank').get(company)

        this.master.ranks.rankValues = ranks.ranks.map(r => r.code)
        this.master.ranks.rankTexts = ranks.ranks.map(r => r.name)
        this.master.ranks.mThresholds = ranks.thresholds.find(
          r => r.type === 'm',
        ).values
        this.master.ranks.fThresholds = ranks.thresholds.find(
          r => r.type === 'f',
        ).values

        // 当期間、前期間ともにランク選択がない場合は初期状態と判断
        if (this.ranks1.length === 0 && this.ranks2.length === 0) {
          this.ranks1 = [...this.master.ranks.rankValues]
          this.ranks2 = [...this.master.ranks.rankValues]
        }
      },
    },
    ranks1: 'rankChangeHandler',
    ranks2: 'rankChangeHandler',
    findRootsBy() {
      this.updateRatio(this.treeFigures1)
    },
  },
  methods: {
    updateRouteQuery(query) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          ranks1: query.ranks1 || this.ranks1.join(','),
          ranks2: query.ranks2 || this.ranks2.join(','),
          findRootsBy: query.findRootsBy || this.findRootsBy,
        },
      })
    },
    /**
     * 顧客一覧ファイルをアップロードして一時顧客グループを作成する
     */
    async uploadCustomerFile(file) {
      this.uploadingCustomerFile = true
      const customerGroup = await this.$customerGroup.upload(file)
      this.uploadingCustomerFile = false

      return customerGroup
    },
    /**
     * クエリの進捗通知（完了）受信時処理
     */
    async loadQueryResult({ id: queryId, status }) {
      if (this.queryId !== queryId) {
        return
      }

      this.querying = false

      if (status === 'Error') {
        throw new Error('分析時にエラーが発生しました。')
      }

      const queryInfo = await this.$longQuery.fetchQueryInfo(
        this.resourceName,
        queryId,
      )

      const isQueryFullFeatured =
        queryInfo.queryFullFeatured !== undefined &&
        queryInfo.queryFullFeatured !== undefined
          ? queryInfo.queryFullFeatured
          : true
      this.$store.commit(SET_IS_QUERY_FULL_FEATURED, isQueryFullFeatured)
      // 制限モードの場合、分析条件で復元不可のものが無いかチェック
      if (!queryInfo.queryFullFeatured) {
        initializeRestrictedQueryFilter(this.queryFilter)
      }

      if (!queryInfo.hasData) {
        this.hasResult = false
        this.showNoResultDialog = true
        return
      }

      this.hasResult = true

      await this.$nextTick()

      const result = await this.fetch()

      this.refresh(result)
    },
    async rankChangeHandler() {
      this.rankChangeSubject.next()
    },
    showTermDialog(target) {
      this.visibleDate = target
      this.visibleTermDialog = true
    },
    showStoreDialog(target) {
      this.visibleStore = target
      this.visibleStoreDialog = true
    },
    async executeQueryFilterSaveWrapper() {
      this.waitingTabSwitch = true
      // TODO 多分顧客条件は保存してはいけない（ファイルは復活できないし、顧客グループIDは一定期間で消えてしまう）
      await this.$longQuery.saveMenuQueryFilter(
        this.resourceName,
        this.queryFilter,
      )
      await this.executeQuery()
    },
    async executeQuery() {
      // 顧客ファイルの指定がある場合、そのままクエリAPIには送信できないので、
      // 一旦アップロードして一時顧客グループIDを取得してから分析に進む。
      if (
        this.queryFilter.customer &&
        !this.queryFilter.customer.customerGroupId &&
        this.queryFilter.customer.file
      ) {
        const customerGroup = await this.uploadCustomerFile(
          this.queryFilter.customer.file,
        )

        if (customerGroup.invalidFile) {
          this.hasCustomerFileUploadWarning = true
          this.customerFileUploadWarningMessage =
            '顧客一覧ファイルが読み込めませんでした。'
          return
        }

        if (customerGroup.numRows === 0) {
          this.hasCustomerFileUploadWarning = true
          this.customerFileUploadWarningMessage =
            '顧客一覧ファイルに有効な顧客が存在しませんでした。'
          return
        }

        this.queryFilter.customer.customerGroupId =
          customerGroup.customerGroupId
      }

      this.querying = true

      const queryInfo = await this.$longQuery.executeQuery(
        this.resourceName,
        this.mapQueryFilterForApi(this.queryFilter),
      )

      // この時点で分析画面（リソース）と条件（画面によっては顧客セグメントがあったり）が
      // 揃っているので、この分析から "遷移できない" ルートの登録を行う。
      // ルートの登録には、前回分析までで潰れたルートに追加するので、referenceでもらった
      // 前回の分析IDも必要です。
      await this.$longQuery.pushBlockRoute(
        {
          ref: this.$route.query.reference,
          prev: this.queryId,
          current: queryInfo.id,
        },
        this.resourceName,
        this.queryFilter.option && this.queryFilter.option.customerSegment,
      )

      await this.$longQuery.saveQueryFilter(queryInfo.id, this.queryFilter)

      // 分析したてなので、フルに機能使えることをstoreに登録
      this.$store.commit(SET_IS_QUERY_FULL_FEATURED, true)

      // 分析IDを取得したので、IDを含む分析結果表示画面に遷移します。
      // 結果表示用URLに遷移するが、実態はこの画面
      const nextPage = {
        name: `query-${this.resourceName}`,
        params: {
          queryId: queryInfo.id,
        },
        query: {
          ranks1: this.ranks1.join(','),
          ranks2: this.ranks2.join(','),
          findRootsBy: this.findRootsBy,
        },
      }

      this.$router.push(nextPage)

      this.waitingTabSwitch = false
    },
    mapQueryFilterForApi(queryFilter) {
      return {
        category: category.mapToApiPayload(queryFilter.category),
        customer: customer.mapToApiPayload(queryFilter.customer),
        term: {
          base: term.mapToApiPayload(queryFilter.term.base),
          compare: term.mapToApiPayload(queryFilter.term.compare),
        },
        store: {
          base: store.mapToApiPayload(queryFilter.store.base),
          compare: store.mapToApiPayload(queryFilter.store.compare),
        },
      }
    },
    applyQueryFilter(queryFilter) {
      category.applyPayload(this.queryFilter.category, queryFilter.category)
      term.applyPayload(this.queryFilter.term.base, queryFilter.term.base)
      term.applyPayload(this.queryFilter.term.compare, queryFilter.term.compare)
      store.applyPayload(this.queryFilter.store.base, queryFilter.store.base)
      store.applyPayload(
        this.queryFilter.store.compare,
        queryFilter.store.compare,
      )
      customer.applyPayload(this.queryFilter.customer, queryFilter.customer)
    },
    async refresh(result) {
      const store1Row = result.find(row => row.store === '1')
      const store2Row = result.find(row => row.store === '2')

      this.updateTreeFigures(this.treeFigures1, {
        amountTotal: store1Row.amount_total1,
        amount: store1Row.amount1,
        qty: store1Row.qty1,
        receipt_count: store1Row.receipt_count1,
        customer_count: store1Row.customer_count1,
      })
      this.updateTreeFigures(this.treeFigures2, {
        amountTotal: store1Row.amount_total2,
        amount: store1Row.amount2,
        qty: store1Row.qty2,
        receipt_count: store1Row.receipt_count2,
        customer_count: store1Row.customer_count2,
      })
      this.updateTreeFigures(this.treeFigures3, {
        amountTotal: store2Row.amount_total1,
        amount: store2Row.amount1,
        qty: store2Row.qty1,
        receipt_count: store2Row.receipt_count1,
        customer_count: store2Row.customer_count1,
      })
      this.updateTreeFigures(this.treeFigures4, {
        amountTotal: store2Row.amount_total2,
        amount: store2Row.amount2,
        qty: store2Row.qty2,
        receipt_count: store2Row.receipt_count2,
        customer_count: store2Row.customer_count2,
      })
      this.updateRatio(this.treeFigures1)
    },
    async fetch() {
      let fetchUrl = await this.$longQuery.getQueryResultFetchUrl(
        this.resourceName,
        this.queryId,
      )

      const ranks1QueryParameter = this.ranks1.map(r => `ranks1=${r}`).join('&')
      const ranks2QueryParameter = this.ranks2.map(r => `ranks2=${r}`).join('&')

      fetchUrl = `${fetchUrl}?${[
        ranks1QueryParameter,
        ranks2QueryParameter,
      ].join('&')}`

      const response = await repository.giggle.get(fetchUrl)

      return response.data
    },
    updateTreeFigures(target, figures) {
      target.amountTotal = figures.amountTotal
      target.amount = figures.amount
      target.compositionRatio =
        figures.amountTotal === 0 ? 0 : figures.amount / figures.amountTotal
      target.customerCount = figures.customer_count
      target.amountPerCustomer = figures.amount / figures.customer_count
      target.receiptPerCustomer = figures.receipt_count / figures.customer_count
      target.amountPerReceipt = figures.amount / figures.receipt_count
      target.qtyPerReceipt = figures.qty / figures.receipt_count
      target.amountPerQty = figures.amount / figures.qty
    },
    updateRatio(target) {
      let calcRatio
      switch (this.findRootsBy) {
        case 'term_x_store':
          calcRatio = key => {
            return (
              this.treeFigures1[key] /
              this.treeFigures2[key] /
              (this.treeFigures3[key] / this.treeFigures4[key])
            )
          }
          break
        case 'term':
          calcRatio = key => {
            return this.treeFigures1[key] / this.treeFigures2[key]
          }
          break
        default:
          throw new Error(`Unknown findRootsBy value: ${this.findRootsBy}`)
      }

      Object.entries(target)
        .filter(([key]) => !key.startsWith('ratio'))
        .forEach(([key]) => {
          const ratioProperty =
            'ratio' + key.slice(0, 1).toUpperCase() + key.slice(1)
          if (target.hasOwnProperty(ratioProperty)) {
            target[ratioProperty] = calcRatio(key)
          }
        })
    },
    async downloadCustomers(store, term) {
      this.downloadingCustomerFile = true

      const fragments = [
        `store=${store}`,
        `customer_count${term}>0`,
        `rank1=${this.ranks1.join('|')}`,
        `rank2=${this.ranks2.join('|')}`,
      ].join(',')

      try {
        const customerGroup = await this.$customerGroup.create(
          this.queryId + '_2',
          [fragments],
        )
        const url = await this.$customerGroup.archive(
          customerGroup.customerGroupId,
        )

        window.open(url)
      } catch (e) {
        this.downloadingCustomerFile = false
        throw e
      }

      this.downloadingCustomerFile = false
    },
    moveToDetail(evaluation, y, sw) {
      const queryParameters = {
        sw,
        evaluation,
        findRootsBy: this.findRootsBy,
        y,
        ranks1: this.ranks1,
        ranks2: this.ranks2,
      }

      this.$router.push(
        `/query-roots-detail?reference=${
          this.queryId
        }&override=${JSON.stringify(queryParameters)}`,
      )
    },
    async downloadExcel() {
      const url = await this.$longQuery.getExcelUrl(
        this.resourceName,
        this.queryId,
        {
          ranks1: this.ranks1,
          ranks2: this.ranks2,
          findRootsBy: this.findRootsBy,
          fThresholds: this.master.ranks.fThresholds,
          mThresholds: this.master.ranks.mThresholds,
        },
      )

      window.open(url)
    },
    moveToHelp() {
      window.open(
        `${process.env.VUE_APP_HELP_SITE_URL_BASE}${this.resourceName}.html`,
      )
    },
    async handleDumpUploaded({ queryFilter, menuCode }) {
      if (this.resourceName !== menuCode) {
        this.$dialog.open(
          DialogWarning,
          'この分析条件はこの画面のものではありません。',
        )
        return
      }

      try {
        const promises = this.applyQueryFilter(queryFilter)
        if (promises && promises.length > 0) {
          await Promise.all(promises.filter(p => p))
        }

        this.snackbar.message = '分析条件を復元しました'
        this.snackbar.show = true
      } catch (error) {
        // ダンプからの復元に失敗した場合は復元処理を中断し、警告を表示する
        // eslint-disable-next-line no-console
        console.error(error)
        this.$dialog.open(
          DialogWarning,
          '分析条件の復元に失敗しました。ダンプファイルが壊れているか、バージョンが異なる可能性があります。',
        )
      }
    },
  },
  async created() {
    // 選択ランクが変更された場合、結果の再取得＆レンダリングが必要です。
    const subscription = this.rankChangeSubject
      .asObservable()
      .pipe(
        filter(() => this.canStartQuery && this.hasResult),
        debounceTime(500),
        switchMap(() => from(this.fetch())),
      )
      .subscribe(result => {
        if (result) {
          this.refresh(result)
        }
      })
    this.$on('hook:beforeDestroy', () => subscription.unsubscribe())

    // クエリ進捗通知受信設定初期化
    const queryNotificationSubscription = this.$queryNotification.observable.subscribe(
      this.loadQueryResult,
    )
    this.$on('hook:beforeDestroy', () =>
      queryNotificationSubscription.unsubscribe(),
    )
  },
}
</script>

<style lang="scss" scoped>
.fixed-header {
  position: fixed;
  display: flex;
  justify-content: flex-end;
  top: 0;
  right: 0;
  padding: var(--spacing-medium);
  z-index: 1;
}

.header {
  display: flex;
  height: 46px;
}

.take-all {
  flex: 1;
}

.header-component-align-right {
  text-align: right;
}

table {
  border-spacing: 0;
  border-collapse: collapse;
  width: 0;
  table-layout: fixed;
  box-sizing: border-box;
}

td {
  border: 1px solid #d5d5d5;
  padding: var(--spacing-medium);
  box-sizing: border-box;
  position: relative;
}

// .stick-top {
//   position: sticky;
//   top: 0;
//   z-index: 10;
// }

.row-header {
  width: 100px;
}

.component-col {
  width: 630px;
}

.header-cell {
  background-color: var(--bg-color-accent);
  color: rgb(255, 255, 255);
  padding: 10px;
  text-align: center;
}

.empty {
  background-color: #e0e0e0;
}

.select-long {
  width: 240px;
}

.tenpo-list {
  list-style-type: none;
  font-size: 12px;
  padding-left: 0;
  text-align: left;
  overflow: auto;
  margin-bottom: 0;
}
.tenpo-list-element {
  padding-bottom: 3px;
}

.fixed-action-area {
  position: fixed;
  bottom: var(--spacing-medium);
  right: var(--spacing-medium);
  z-index: 11;
}

.error {
  color: var(--color-warn, #ef5350);
  font-size: var(--font-size-small);
}

.spinner-container {
  position: relative;
  align-items: center;
  display: flex;
  height: 200px;
  justify-content: center;
  width: 100%;

  img {
    position: absolute;
    width: 200px;
    opacity: 0.4;
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
    &:hover {
      opacity: 0.8;
      transform: scale(1.1);
    }
  }
}

.find-roots-by {
  position: absolute;
  top: 0;
  right: var(--spacing-small);
  width: 250px;
}

.filter-open-link {
  color: #00e5ff !important;
  text-decoration: underline;
}

// Dialogs
.category-dialog,
.store-dialog {
  min-width: 600px;
}
</style>

<style lang="scss">
.md-select-menu {
  z-index: 10001 !important;
}
</style>
